document.addEventListener( 'click', function ( e ) {
	const link = e.target.closest( '.sponsored-research-pagination a.page-numbers' );

	if ( ! link ) {
		return;
	}

	e.preventDefault();

	const wrapper = document.querySelector( '.sponsored-research-wrapper' );
	if ( ! wrapper ) {
		window.location.href = link.href;
		return;
	}

	const loader = wrapper.querySelector( '.sponsored-research-loader' );
	if ( loader ) {
		loader.classList.add( 'is-active' );
	}

	fetch( link.href, {
		credentials: 'same-origin',
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
		},
	} )
		.then( function ( response ) {
			return response.text();
		} )
		.then( function ( html ) {
			const temp = document.createElement( 'div' );
			temp.innerHTML = html;

			const newWrapper = temp.querySelector( '.sponsored-research-wrapper' );
			if ( ! newWrapper ) {
				window.location.href = link.href;
				return;
			}

			wrapper.replaceWith( newWrapper );

			const target = document.getElementById( 'sponsored-research' );
			if ( target ) {
				const headerOffset = 120;
				const elementPosition = target.getBoundingClientRect().top;
				const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

				window.scrollTo( {
					top: offsetPosition,
					behavior: 'smooth',
				} );
			}
		} )
		.catch( function () {
			window.location.href = link.href;
		} );
} );
